// recording source chooser directive
//
//   <recording-source-chooser edit-or-create-event-service="vm.service" />
//

let module = angular.module('app.directives');

module.directive('recordingSourceChooserPreview', () => {
  return {
    restrict: 'E',
    scope: {
      broadcast: '=',
    },
    template: `
      <div>
        <div style="display: inline-flex; float: left; width: 32px; height: 18px; margin-top: 1px; margin-right: 6px;"
             ng-style="{
               'background-image': 'url(&quot;' + broadcast.preview + '&quot;)',
               'background-size': 'contain',
               'background-repeat': 'no-repeat'
             }">
        </div>
        <div class="date-range" style="display: inline-flex; float: right; margin-left: 6px;">
          ({{broadcast.starts_at | date}})
        </div>
        <div class="overflow-ellipse">
          {{broadcast.name}}
        </div>
      </div>
    `,
  };
});

module.directive('recordingSourceChooser', () => {
  return {
    restrict: 'E',
    scope: {
      editOrCreateEventService: '=',
      onSelectBroadcast: '=',
      selectSourceTitle: '@',
      skipRecordingSourceValidation: '=',
      modalTitle: '@',
      broadcastValidator: '=',
    },
    template: `
      <div ng-show="editOrCreateEventService.sourceBroadcast"
           ng-click="chooseSource($event)"
           style="border: 1px solid #ccc; border-radius: 4px; padding: 8px;"
           ng-style="style">
        <recording-source-chooser-preview broadcast="editOrCreateEventService.sourceBroadcast"></recording-source-chooser-preview>
      </div>
      <div ng-show="!editOrCreateEventService.sourceBroadcast"
           ng-click="chooseSource($event)"
           style="border: 1px solid #ccc; color: #757575; border-radius: 4px; padding: 8px;"
           ng-style="style">
        <span ng-show="!editOrCreateEventService.sourceBroadcastUnavailable">
          {{::(selectSourceTitle || 'Select Source...')}}
        </span>
        <span ng-show="editOrCreateEventService.sourceBroadcastUnavailable">
          Source Broadcast Unavailable
        </span>
      </div>
    `,
    controller: function ($scope, $uibModal) {
      'ngInject';

      $scope.style = {};
      if (($scope.editOrCreateEventService.broadcast.timeframe || 'future') == 'future') {
        $scope.style.cursor = 'pointer';
      } else {
        $scope.style.cursor = 'not-allowed';
        $scope.style['background-color'] = '#eee';
        _.each(
          ['-webkit-', '-khtml-', '-moz-', '-o-', ''],
          (prefix) => ($scope.style[`${prefix}user-select`] = 'none')
        );
      }

      $scope.chooseSource = ($event) => {
        if ($event.cancelable) {
          $event.preventDefault();
        }
        if (($scope.editOrCreateEventService.broadcast.timeframe || 'future') != 'future') return;
        $uibModal
          .open({
            template: require('./recording-source-chooser-browse.html'),
            controller: require('./recording-source-chooser-browse.js').default,
            size: 'lg',
            controllerAs: 'vm',
            resolve: {
              options: () => ({
                activeTabIndex: 2, // start on past broadcast tab
                skipRecordingSourceValidation: $scope.skipRecordingSourceValidation,
                modalTitle: $scope.modalTitle,
                broadcastValidator: $scope.broadcastValidator,
              }),
            },
          })
          .result.then((broadcast) => {
            $scope.editOrCreateEventService.updateSourceBroadcast(broadcast);
            $scope.onSelectBroadcast && $scope.onSelectBroadcast(broadcast);
          });
      };
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/recording-source-chooser.js